import React from 'react'
import UCButton from "../../buttons";
import { FormattedMessage } from "react-intl";
import { colors } from "../../../constants/colors";

const CustomSubmitButton = (props) => {
  const { className, buttonClassName, style, buttonStyle, disabled, content, onSubmit, files, correctNumberOfCommas, emailColumnPresent } = props

  const _disabled =
    files.some(f => ['preparing', 'getting_upload_params', 'uploading'].includes(f.meta.status)) ||
    !files.some(f => ['ready'].includes(f.meta.status)) ||
    !correctNumberOfCommas ||
    !emailColumnPresent

  const handleSubmit = () => {
    onSubmit(files.filter(f => ['headers_received', 'done'].includes(f.meta.status)))
  }

  return (
    <UCButton
      spinner={{
        name: "uploadFileSpinner",
        size: 20,
      }}
      className={buttonClassName}
      style={buttonStyle}
      type="primary"
      text={<FormattedMessage id="peopleHeader.modalUpload.upload" />}
      dataTestId="uploadbulk"
      onClick={handleSubmit}
      disabled={disabled || _disabled}
    />
  )
}

export default CustomSubmitButton